module.exports = __webpack_public_path__ + "pc/img/swiper_08.f576931c.jpg";